import { render } from "./DataEntryReport.vue?vue&type=template&id=72c8458c&scoped=true"
import script from "./DataEntryReport.vue?vue&type=script&lang=js"
export * from "./DataEntryReport.vue?vue&type=script&lang=js"

import "./DataEntryReport.vue?vue&type=style&index=0&id=72c8458c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c8458c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
